import { render, staticRenderFns } from "./ChatChartBlock.vue?vue&type=template&id=e2f599ba&scoped=true"
import script from "./ChatChartBlock.vue?vue&type=script&lang=js"
export * from "./ChatChartBlock.vue?vue&type=script&lang=js"
import style0 from "./ChatChartBlock.vue?vue&type=style&index=0&id=e2f599ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f599ba",
  null
  
)

export default component.exports